import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../components/tables/dynamic-table1";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import moment from "moment";
import {
  customerDeleteAction,
  customerTableAction,
} from "../../redux/actions/customer-action";
import CustomerFilter from "../../components/tables/table-filter/customer-filter";
import { DataContext } from "../../components/layouts/main-layout";
import { useHotkeys } from "../../components/helper-components/use-hotkeys";

const InvoiceTable = () => {
  const { permissionFn } = useContext(DataContext);
  const [heading, setHeading] = useState([]);
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "cmr_phone_number",
    from: "",
    to: "",
    inputValue: "",
    customer_status: "",
  });

  useEffect(() => {
    dispatch(
      customerTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const cusData = parsed.find((obj) => obj?.customer_list);
      if (cusData?.customer_list) {
        setHeading(cusData.customer_list);
      }
    }
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setCustomers(data?.data?.customerList);
    setDataCount(data?.data?.totalCount);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = customers?.map((item) => {
    return {
      id: item?.cmr_id,
      cmr_phone_number: item?.cmr_phone_number ?? "--",
      cmr_first_name: item?.cmr_first_name ? item?.cmr_first_name : "--",
      is_corporate_cmr: item?.is_corporate_cmr ? "Corporate" : "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      total_order_value: "₹ " + item?.total_order_value,
    };
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <CustomerFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;
  useHotkeys("escape", () => {
    setShowFilter(false);
  });

  return (
    <InnerLayout
      list={true}
      onclkFn={() => navigate("/add-customer")}
      title="Customers"
      module="customer"
      permissionFn={permissionFn}
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTable
            is_checkbox_req={false}
            onClickItemFn={(id) => navigate(`/view-customer/${id}`)}
            list={true}
            onclkFn={() => {
              navigate("/add-customer");
            }}
            permissionFn={permissionFn}
            module={"customer"}
            path="customer"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={customerDeleteAction}
            label="Customer"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "cmr_phone_number",
              from: "",
              to: "",
              inputValue: "",
              customer_status: "",
            }}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default InvoiceTable;
const tableHeading = [
  {
    label: "CUSTOMER PHONE",
    value: "cmr_phone_number",
    display: false,
    column: true,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_first_name",
    display: true,
    column: true,
  },
  {
    label: "TYPE",
    value: "is_corporate_cmr",
    display: false,
    column: false,
  },
  {
    label: "ACTIVE FROM",
    value: "created_date",
    display: true,
    column: false,
  },
  {
    label: "TOTAL SALE AMOUNT",
    value: "total_order_value",
    display: true,
    column: false,
  },
  {
    label: "",
    value: "",
    column: false,
  },
];
